export default __webpack_public_path__ + "static/media/menu.82bd2618.svg";